import React, { useState, useEffect, useRef } from "react";
import { StartLoading, StopLoading } from "../../../Shared-ui/Store/LoadingReducer/LoaderActions";
import MetaInstance, { MetaMultipartInstance } from "../../../Services/AxiosInstance/MetaInstance";
import { FILE_UPLOAD_AGENT, GET_AGENT, RUN_MODEULE } from "../../../Services/Endpoint";
import OldAgent from "../../../Shared-ui/Types/OldAgent";
import { Params, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { ShowError, ShowSuccess } from "../../../Shared-ui/Store/MessageReducer/MsgActions";
import { MessageOld, QueryOld } from "../../../Shared-ui/Types/OldPlayground";
import { v4 as uuidv4 } from "uuid";
import ChatInstance from "../../../Services/AxiosInstance/ChatInstance";
import { SplitFileIntoChuncks } from "../../../Shared-ui/utils/File/FileHelpers";
import { marked } from 'marked';
import PlaygroundWindow from "./PlaygroundWindow";
import { JsonToTable } from "react-json-to-table";
import { JSX } from "react/jsx-runtime";
import { FileSizeException } from "../../../Shared-ui/Exceptions/FileException";



const PlaygroundHandler = () => {


  const { agentId } = useParams<Params>();

  const questionInitial = {
    assistantId: agentId,
    sessionId: uuidv4(),
    query: "",
    stream: false,
    prompt: "",
  };
  const [messages, setMessages] = useState<MessageOld[]>([]);
  const [inputValue, setInputValue] = useState<string>("");
  const [file, setFile] = useState<File | null>(null); // To store the selected file

  const [open, setOpen] = useState(false);
  const [scrollPercentage, setScrollPercentage] = useState(0);

  const [typing, setTyping] = useState(false);
  const [knowledgeBase, setknowledgeBase] = useState<OldAgent>();
  const dispatch = useDispatch();
  const [questionData, setQuestionData] = useState<QueryOld>(questionInitial)
  const [Progress, setProgress] = useState(0)

  useEffect(() => {
    getknowledgeBase();
  }, []);



  const getknowledgeBase = async () => {
    try {
      dispatch(StartLoading());
      const data = await MetaInstance.get(`${GET_AGENT}/${agentId}`).then(
        (res) => res?.data?.detail
      );
      setknowledgeBase(data.response);
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail?.response));
    } finally {
      dispatch(StopLoading());
    }
  };



  const handleSendMessage = async () => {
    if (questionData?.query?.trim()) {
      setMessages((prev) => [
        ...prev,
        {
          text: questionData.query,
          type: "outgoing",
        },
      ]);
    }
    setTyping(true)
    try {
      const data = await ChatInstance.post(RUN_MODEULE, questionData).then(
        (res) => res?.data?.detail

      );
      const msg = await markupTohtml(data.response)
      setMessages((prev) => [
        ...prev,
        {
          text: msg,
          pandasInstruction: data.response?.pandasInstruction,
          resultType: data.response?.resultType,
          // text: data.response,
          type: "incoming",
        },
      ]);
      setTyping(false);
      // textFieldRef.current?.focus();
      setFile(null);
    } catch (err: any) {
      dispatch(ShowError("Something went wrong"));
    } finally {
      setTyping(false);
      // textFieldRef.current?.focus();
      setFile(null);
    }



  };
  const handleClickPrompt = async (promptName: string) => {
    var promptPayload = questionData
    if (promptName) {
      let lastMessage: any = messages[messages.length - 1]
      let query = lastMessage?.text ? lastMessage?.text : ""
      promptPayload.prompt = promptName
      promptPayload.query = query
    }
    try {
      setTyping(true)
      const data = await ChatInstance.post(RUN_MODEULE, promptPayload).then((res) => res?.data?.detail)
      const msg = await markupTohtml(data.response)
      setMessages((prev) => {
        return [...prev, {
          text: msg,
          pandasInstruction: data.response?.pandasInstruction,
          resultType: data.response?.resultType,
          // text: data.response,
          type: "incoming",
        },
        ]
      });
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail?.response));
    } finally {
      setTyping(false);
      // textFieldRef.current?.focus();
      setFile(null); // Reset the file inpu\
      setQuestionData((preVal) => ({ ...preVal, prompt: "" }));
    }
  };

  const uploadChunk = (chunk: any, file: File, index: number, totalChunks: number, fileId: string, progressCallback: any) => {
    const formData = new FormData();
    formData.append("file", chunk)
    formData.append("chunkNumber", String(index))
    formData.append("totalChunks", String(totalChunks))
    formData.append("fileId", fileId)
    formData.append("fileName", file.name)

    // formData.forEach((value, key) => {
    //   if (value instanceof File) {
    //     console.log(`${key}: ${value.name} (File)`);
    //   } else {
    //     console.log(`${key}: ${value}`);
    //   }
    // });
    const pathname = window.location.pathname;
    const basePath = pathname.split('/').slice(0, -1).join('/');

    return MetaMultipartInstance.post(`${FILE_UPLOAD_AGENT}/${agentId}/session/${questionData.sessionId}/session-upload-chunk`, formData, {
      onUploadProgress: (progressEvent) => {
        if (progressEvent.total) {
          const progress = (progressEvent.loaded / progressEvent.total) * 100;
          progressCallback(file.name, index, progress);
        }
      },
    });
  }

  const uploadFiles = async (files: File[]) => {
    const allowedFileExtensions = ["txt", "doc", "docx", "xls", "xlsx", "csv", "pdf", "jpg", "png"];

    const uploadPromises = files.map(async (file) => {
      const chunkSize = 5 * 1024 * 1024
      const chunks = SplitFileIntoChuncks(file)
      const fileId = uuidv4()
      const maxSize = 25 * 1048576; // 25 MB
      // show file upload details in chat window
      if (file.size > maxSize) {
        throw new FileSizeException(`${file.name} size is larger`)
      } else {
        setMessages((prev) => [...prev, {
          file: file,
          type: "file",
        }]);
        setTyping(true)
        // for progrss status
        const fileProgress = (filename: string, chunkIndex: number, progress: number) => {
          if (Math.round(progress) == 100) {
            // console.log(chunkSize / file.size *100)
          }
          setProgress(Math.round(progress))
          // console.log(`Uploading ${filename} - Chunk ${chunkIndex + 1}/${chunks.length}: ${Math.round(progress)}%`);
        };

        for (let i = 0; i < chunks.length; i++) {
          await uploadChunk(chunks[i], file, i + 1, chunks.length, fileId, fileProgress);
        }
      }
    })
    await Promise.all(uploadPromises).then(res => {
      setMessages((prev) => [...prev, {
        text: `uploading done`,
        type: "incoming",
      }]);
      setTyping(false)
      setProgress(0)
    }).catch(err => {
      if (err instanceof FileSizeException) {
        dispatch(ShowError("File size is geater than 25MB"))
      }
      setTyping(false)

    }).finally(

    )
  }


  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {// Simulating incoming message after a delay
      handleSendMessage();
    }
  };




  const markupTohtml = async (text: any) => {
    try {
      var newStr
      if (text.resultType && text.result) {
        return text.result
      } else {
        newStr = await marked.parse(text)
        return newStr
      }
    } catch (err) {
      return 'newStr'
    }
  }


  return (
    <>
      <PlaygroundWindow
        handleClickPrompt={handleClickPrompt}
        uploadFiles={uploadFiles}
        knowledgeBase={knowledgeBase}
        handleSendMessage={handleSendMessage}
        messages={messages}
        setQuestionData={setQuestionData}
        typing={typing}
      />
    </>
  );
};

export default PlaygroundHandler;
